import React from 'react';
import PropTypes from 'prop-types';

/**
 * Icône « checklist » dans le style des autres icônes du menu : glyphe
 * entièrement rempli via la prop `fill` (blanc, ou bleu quand l'entrée est
 * active), sans contour noir.
 */
const ChecklistIcon = ({ color, fill, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 35 35">
    <g color={color} fill={fill} fillRule="evenodd" clipRule="evenodd">
      {/* Corps du bloc-notes (contour) */}
      <path d="M9 6h17a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3Zm0 2a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z" />
      {/* Pince du haut */}
      <path d="M13 3h9a2 2 0 0 1 2 2v3H11V5a2 2 0 0 1 2-2Z" />
      {/* Coche */}
      <path d="M12 16.5l2.2-2.2 2.9 2.9 5.2-5.2 2.2 2.2-7.4 7.4z" />
      {/* Lignes */}
      <path d="M12 24.5h10v2H12zM12 28.5h7v2h-7z" />
    </g>
  </svg>
);

ChecklistIcon.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ChecklistIcon.defaultProps = {
  color: '#000',
  fill: '#fff',
  width: 35,
  height: 35,
};

export default ChecklistIcon;
